import { useEffect, useRef, useCallback } from 'react';

/** One initial application per mounted game session; explicit choices always win. */
export function useAssignedClayAvatar(ready: boolean, hasTraits: boolean, busy: boolean, apply: () => void | Promise<unknown>) {
  const resolved = useRef(false);
  const applyRef = useRef(apply);
  applyRef.current = apply;
  const markChosen = useCallback(() => { resolved.current = true; }, []);
  useEffect(() => {
    if (!ready || !hasTraits || busy || resolved.current) return;
    resolved.current = true;
    // The caller handles request failures and shows a retryable picker error.
    void applyRef.current();
  }, [ready, hasTraits, busy]);
  return markChosen;
}
